import ajax from '@/libs/api.request'

export default {
  daily : param => {
    return ajax.get('/edu/web/report/daily', param)
  },
  classhour : param => {
    return ajax.get('/edu/web/report/classhour', param)
  },
  msg: param =>{
    return ajax.get('/edu/web/report/msg', param)
  },
  cancelclass:param =>{
    return ajax.get('/edu/web/report/cancelclass', param)
  },
  cancelclassdetail:param =>{
    return ajax.get('/edu/web/report/cancelclassdetail', param)
  },
  attendance:param =>{
    return ajax.get('/edu/web/report/attendance', param)
  },
}

